import { render } from "./Or_selectSupplier.vue?vue&type=template&id=64acac70&scoped=true&ts=true"
import script from "./Or_selectSupplier.vue?vue&type=script&lang=ts"
export * from "./Or_selectSupplier.vue?vue&type=script&lang=ts"

import "./Or_selectSupplier.vue?vue&type=style&index=0&id=64acac70&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64acac70"]])

export default __exports__